const closeEnough = (ms, iso1, iso2) => {
  const t1 = new Date(iso1).getTime();
  const t2 = new Date(iso2).getTime();
  return t2 - t1 < ms;
};

const isSameDay = (iso1, iso2) => {
  const date1 = new Date(iso1);
  const date2 = new Date(iso2);
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

const reducer = (acc, curr, index, initialArray) => {
  const previous = index ? initialArray[index - 1] : undefined;

  // Check if we need a date separator
  if (previous && !isSameDay(previous.createdAt, curr.createdAt)) {
    acc.push({
      type: 'date-separator',
      date: curr.createdAt,
      id: `date-separator-${curr.createdAt}`,
    });
  } else if (!previous) {
    // Add date separator for the first message
    acc.push({
      type: 'date-separator',
      date: curr.createdAt,
      id: `date-separator-${curr.createdAt}`,
    });
  }

  const sameUser = previous && previous.writer === curr.writer;
  const quickEnough =
    previous && closeEnough(60000, previous.createdAt, curr.createdAt);
  const currentOrPreviousEdited =
    (previous && previous.editedAt) || curr.editedAt;
  const sameDay = previous && isSameDay(previous.createdAt, curr.createdAt);

  // Find the last message group (not date separator)
  const lastMessageGroup = acc
    .slice()
    .reverse()
    .find((item) => item.type !== 'date-separator');

  if (
    lastMessageGroup &&
    sameUser &&
    quickEnough &&
    !currentOrPreviousEdited &&
    sameDay
  ) {
    lastMessageGroup.messages.push(curr.id);
  } else {
    acc.push({
      type: 'message-group',
      author: curr.writer,
      createdAt: curr.createdAt,
      messages: [curr.id],
    });
  }
  return acc;
};

const groupMessages = (messages) => messages.reduce(reducer, []);

export default groupMessages;
